import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/smartAdminUI/Button';

const OfficeActionButtons = ({
  viewClicked,
  auditClicked,
  currRow,
  isEditable,
  isAuditable,
}) => {
  const onViewClick = () => viewClicked(currRow);
  const onAuditClick = () => auditClicked(currRow);

  return (
    <div className="d-flex">
      {isEditable && (
        <Button
          name="btnViewOffice"
          variant="primary iconCenter"
          onClick={onViewClick}
          tooltipText="View Office"
        >
          <i className="far fa-ellipsis-h" />
        </Button>
      )}
      {isAuditable && (
        <Button
          name="btnAuditOffice"
          variant="primary iconCenter"
          onClick={onAuditClick}
          tooltipText="Audit Office"
        >
          <i className="far fa-history" />
        </Button>
      )}
    </div>
  );
};
OfficeActionButtons.propTypes = {
  viewClicked: PropTypes.func.isRequired,
  auditClicked: PropTypes.func.isRequired,
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
  }),
  isAuditable: PropTypes.bool.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

export default OfficeActionButtons;
